import BaseEntity from '@/entity/BaseEntity';
import { useNotif } from '@orion.ui/orion';
import useLanguageService from '@/services/LanguageService';
import type UserProfileInformationsEntity from './user-profile/UserProfileInformationsEntity';

export default class UserLanguageEntity extends BaseEntity<IUserLanguageModel> {
	private userProfileInformationsEntity?: UserProfileInformationsEntity;

	get id () { return this.state.id; }
	get language () { return this.state.language; }
	set language (val) { this.state.language = val; }
	get languageLevel () { return this.state.languageLevel; }
	set languageLevel (val) { this.state.languageLevel = val; }
	get userId () { return this.state.userId; }

	get dataForApiAdd (): IAddUserLanguageModel {
		return {
			languageLevel: this.languageLevel,
			language: this.language,
		};
	}

	connectUserProfileInformationsEntity (userProfileInformationsEntity: UserProfileInformationsEntity) {
		this.userProfileInformationsEntity = userProfileInformationsEntity;
	}

	async addAsync (cb?: Function) {
		try {
			const data = await useLanguageService().addUserLanguageAsync(this.dataForApiAdd);
			this.userProfileInformationsEntity?.addLanguage(data);
			if (cb) cb();
		} catch (e:any) {
			useNotif.danger(`Oops`, e?.response?.data);
		}
	}

	async deleteAsync (cb?: Function) {
		try {
			await useLanguageService().deleteUserLanguageAsync(this.id);
			this.userProfileInformationsEntity?.deleteLanguage(this.id);
			if (cb) cb();
		} catch (e:any) {
			useNotif.danger(`Oops`, e?.response?.data);
		}
	}
}
